import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getStartAPetitionPageData } from './api';
import type { StartAPetitionPageDataErrorCode } from './types';

export const {
	Context: StartAPetitionPageDataContext,
	Provider: StartAPetitionPageDataContextProvider,
	useContext: useStartAPetitionPageData,
	useAsyncData: useStartAPetitionPageDataFromApi,
	prefetchAsyncData: prefetchStartAPetitionPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'StartAPetitionPageDataContext',
	dataProperty: 'pageData',
	getData: getStartAPetitionPageData,
	errorHandler: pageDataErrorHandler<StartAPetitionPageDataErrorCode>(),
});
